export const API_CONFIG = {
  BASE_URL: "https://api.jscpayment.com",
  ENDPOINTS: {
    AUTHENTICATE: "/api/payment/v2/User/authenticate",
    BUSINESSES: "/businesses",
    ACCOUNTS: (businessId: string) =>
      `/api/payment/v2/admin/${businessId}/accounts`,
    USERS: (businessId: string) => `/api/payment/v2/admin/${businessId}/users`,
    ADD_USER: (businessId: string) =>
      `/api/payment/v2/admin/${businessId}/add-user`,
    UPDATE_USER_ADMIN: (businessId: string, userId: string) =>
      `/api/payment/v2/admin/${businessId}/update-user/${userId}`,
    UPDATE_USER: (userId: string) =>
      `/api/payment/v2/user/${userId}/update-user`,
    RESET_PASSWORD_ADMIN: (businessId: string, userId: string) =>
      `/api/payment/v2/admin/${businessId}/force-reset-password/${userId}`,
    RESET_PASSWORD: (userId: string) =>
      `/api/payment/v2/user/${userId}/reset-password`,
    TRANSACTIONS: (businessId: string) =>
      `/api/payment/v2/cp/${businessId}/transactions`,
    ADD_TRANSACTION: (accountId: string, terminalId: string) =>
      `/api/payment/v2/cp/${accountId}/cp/sale/${terminalId}`,
  },
};
